export const ROUTE = "/"
// export const SERVER = "http://113.163.216.208:5002";
const current_url = window.location.href;
//const current_url = 'https://tlc-freight.ailab.vn/';
const http_ = current_url.split('/')[2];
export const IP = http_.split(':')[0];
export const SERVER = "https://prev-freight.tlcommodities.com/api";
